import { useEffect } from 'react';
import { RouterProvider } from 'react-router';

import { AlertComponent } from '@workinance/shared/ui/AlertComponent';
import { OfflineStatusComponent } from '@workinance/shared/ui/OfflineStatusComponent';

import { applicationRoutes } from '@/routes/app.routes';
import { useAuthStore } from '@/store/auth.store';

function App() {
	// Route guards only run on navigation. When the session changes without one (signed out because the
	// refresh token expired, the account activated, the business gone) they run again, so the page follows.
	useEffect(
		() =>
			useAuthStore.subscribe((state, previousState) => {
				const hasSessionChanged =
					state.isAuthenticated !== previousState.isAuthenticated ||
					state.user?.status !== previousState.user?.status ||
					state.business?.id !== previousState.business?.id;
				if (hasSessionChanged) void applicationRoutes.revalidate();
			}),
		[],
	);

	return (
		<>
			<AlertComponent />
			<RouterProvider router={applicationRoutes} />
			<OfflineStatusComponent />
		</>
	);
}

export default App;
